import { render, staticRenderFns } from "./myClass.vue?vue&type=template&id=b30052c6&scoped=true"
import script from "./myClass.vue?vue&type=script&lang=js"
export * from "./myClass.vue?vue&type=script&lang=js"
import style0 from "./myClass.vue?vue&type=style&index=0&id=b30052c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30052c6",
  null
  
)

export default component.exports